module.exports = __webpack_public_path__ + "img/1.748fe8a3.jpg";